import React from "react";
import { FIELD_REGISTRY } from "./Config/fieldRegistry";

function ProductInventoryInformation({
    formData,
    handleNumberInput,
    handleChange,
    errors,
    units = [],
    config,
     inventoryItems = [],
    addInventoryItem,
    deleteInventoryItem,
    setInventoryForm,
     inventoryForm,
    editInventoryIndex,
    setEditInventoryIndex
}) {
    const inventoryFields = config?.fields?.inventory || [];
    if (inventoryFields.length === 0) return null;
    return (
        <div className="card mb-3">
            <div className="card-header">
                <h5>Inventory Information</h5>
            </div>
            <div className="card-body">
                <div className="row">
                    {inventoryFields.map((fieldName) => {
                           const fieldConfig = FIELD_REGISTRY[fieldName];
                        if (!fieldConfig) return null;

                        const { type, label, required, placeholder } = fieldConfig;
                        if (type === 'select') {
                            let options = fieldName === 'unit_id' ? units : (fieldConfig.options || []);
                            return (
                                <div className="col-md-6 mb-3" key={fieldName}>
                                    <label className="form-label">
                                        {label} {required && <span className="text-danger">*</span>}
                                    </label>
                                    <select
                                        className={`form-control ${errors?.[fieldName] ? "is-invalid" : ""}`}
                                        name={fieldName}
                                        value={formData[fieldName] || ""}
                                        onChange={handleChange}
                                    >
                                        <option value="">Select {label}</option>
                                        {Array.isArray(options) && options.map((opt) => (
                                            <option key={opt.id || opt.value || opt} value={opt.id || opt.value || opt}>
                                                {opt.name || opt.label || opt}
                                            </option>
                                        ))}
                                    </select>
                                    {errors?.[fieldName] && (
                                        <div className="invalid-feedback">{errors[fieldName]}</div>
                                    )}
                                </div>
                            );
                        }
                        return (
                            <div className="col-md-6 mb-3" key={fieldName}>
                                <label className="form-label">
                                    {label} {required && <span className="text-danger">*</span>}
                                </label>
                                <input
                                    type="text"
                                    className={`form-control ${errors?.[fieldName] ? "is-invalid" : ""}`}
                                    placeholder={placeholder || `Enter ${label}`}
                                    name={fieldName}
                                    value={formData[fieldName] || ""}
                                    onChange={handleNumberInput}
                                />
                                {errors?.[fieldName] && (
                                    <div className="invalid-feedback">{errors[fieldName]}</div>
                                )}
                            </div>
                        );
                    })}

                </div>
            </div>
        </div>
    );
}

export default ProductInventoryInformation;